// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"04c6ca8a","239":"1b90d6ce","667":"1de81596"}[chunkId] + ".chunk.js";
};